/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Tournaments_Total_CountInputs */



/**
* | output |
* | --- |
* | "{count} tournaments" |
*
* @param {Tournaments_Total_CountInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournaments_total_count = /** @type {((inputs: Tournaments_Total_CountInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_Total_CountInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.count} tournois`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.count} torneos`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`${i?.count} torneios`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.count} tornei`)
	return /** @type {LocalizedString} */ (`${i?.count} tournaments`)
});